import { HoldResponseDto } from '@planning/app/api'
import { EntityItem } from '@planning/rt-stores/base/EntityItem'
import { IContainerItem } from '@planning/rt-stores/container/ContainerItem'
import { ContainerItemStore } from '@planning/rt-stores/container/ContainerItemStore'
import { IEntity } from '@planning/rt-stores/types'
import _ from 'lodash'
import { computed, makeObservable } from 'mobx'
import { IContainerJourneyItem } from '../../pages/Issues/Stores/ContainerJourneyItem'
import { ContainerJourneyItemStore } from '../../pages/Issues/Stores/ContainerJourneyItemStore'

export interface IHoldItem extends IEntity<HoldResponseDto> {
  containerJourney: IContainerJourneyItem | undefined
  container: IContainerItem | undefined
  holdTitle: string
}

export class HoldItem extends EntityItem<HoldResponseDto> implements IHoldItem {
  constructor(
    public containerJourneyItemStore: ContainerJourneyItemStore,
    public containerItemStore: ContainerItemStore,
    id: number,
    data: HoldResponseDto,
  ) {
    super(id, data)
    makeObservable(this, {
      holdType: computed,
      containerJourney: computed,
      container: computed,
      holdTitle: computed,
    })
  }

  get containerJourney() {
    return _(this.containerJourneyItemStore.elements).find(
      elm => elm.id === this.data.containerJourneyId,
    )
  }

  get container() {
    const containerId = this.containerJourney?.data.containerId

    return containerId ? this.containerItemStore.elements[containerId] : undefined
  }

  get holdTitle() {
    return `${this.data.holdType.name} - ${this.data.containerJourneyId}`
  }

  get holdType() {
    return this.data.holdType
  }
}
